var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndustries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "category"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_106_3100",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_106_3100)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "category_2",
    d: "M5.41667 9.1665L10 1.6665L14.5833 9.1665H5.41667ZM14.5833 18.3332C13.5417 18.3332 12.6562 17.9686 11.9271 17.2394C11.1979 16.5103 10.8333 15.6248 10.8333 14.5832C10.8333 13.5415 11.1979 12.6561 11.9271 11.9269C12.6562 11.1978 13.5417 10.8332 14.5833 10.8332C15.625 10.8332 16.5104 11.1978 17.2396 11.9269C17.9688 12.6561 18.3333 13.5415 18.3333 14.5832C18.3333 15.6248 17.9688 16.5103 17.2396 17.2394C16.5104 17.9686 15.625 18.3332 14.5833 18.3332ZM2.5 17.9165V11.2498H9.16667V17.9165H2.5ZM14.5833 16.6665C15.1667 16.6665 15.6597 16.4651 16.0625 16.0623C16.4653 15.6596 16.6667 15.1665 16.6667 14.5832C16.6667 13.9998 16.4653 13.5068 16.0625 13.104C15.6597 12.7012 15.1667 12.4998 14.5833 12.4998C14 12.4998 13.5069 12.7012 13.1042 13.104C12.7014 13.5068 12.5 13.9998 12.5 14.5832C12.5 15.1665 12.7014 15.6596 13.1042 16.0623C13.5069 16.4651 14 16.6665 14.5833 16.6665ZM4.16667 16.2498H7.5V12.9165H4.16667V16.2498ZM8.375 7.49984H11.625L10 4.87484L8.375 7.49984Z",
    fill: "url(#paint0_linear_106_3100)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_3100",
    x1: 10.4167,
    y1: 1.6665,
    x2: 10.4167,
    y2: 18.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustries);
export default __webpack_public_path__ + "static/media/industries.654309502f5a998945b02439f3d9a494.svg";
export { ForwardRef as ReactComponent };